module.exports = __webpack_public_path__ + "static/WEDDING E&M-511-28eb593e96806d6d030dfe17eb14a5ec.jpg";